// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {

	$(document).ready(function () {

		

		$('[data-fancybox').fancybox({
			btnTpl : {
				smallBtn : '<div data-fancybox-close class="fancybox-close-small modal-close"><em class="icon"><span class="line"></span><span class="line"></span></em></div>'
			}
		});




		// Main Nav Dropdown
		$("#primary-nav li").hover(function () {
			$(this).addClass("hover");
			$('ul.submenu', this).fadeIn(200);
		}, function () {
			$(this).removeClass("hover");
			$('ul.submenu', this).fadeOut(200);
		});

		//Menu
		let menuBtn = document.querySelector('.js-menu');
		let menuBtnM = document.querySelector('.js-menu-m');

		const menuClose = document.querySelector('.js-close');
		const menu = document.querySelector('.menu-block');

		menuClose.addEventListener('click', function (e) {
			e.preventDefault();
			menu.classList.remove('active');
		})

		// menuBtn.addEventListener('click', function (e) {
		// 	e.preventDefault();
		// 	menu.classList.add('active')
		// })
		menuBtnM.addEventListener('click', function (e) {
			e.preventDefault();
			menu.classList.add('active')
		})

		$(function () { // TOGGLE CLASS ON ELEMENT
			$(menuBtn).on("click", function () {
				$(menu).toggleClass('active');
			});
		}); //END TOGGLE CLASS

		$(function () {  // REMOVE CLASS WHEN YOU CLICK, EXCLUDE ELEMENTS
			var ignore = Array( // elements to ignore
			menuBtn, menuBtnM);
			ignore.forEach(function (item) { // loop through ignore array
				$(item).click(function () { 
					return false; 
				}); // ignore item
			});
			$(document).on("click", function () { // remove class when you click anywhere else
				$(menu).removeClass('active');
			});
		});// END REMOVE CLASS


		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			console.log("wtf");
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
		$("#CheckIn").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$("#CheckOut").datepicker("setDate", newDate);
				$("#CheckOut").datepicker("option", "minDate", selectedDate);
			}
		});
		$("#CheckOut").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		$('.open-booking-widget-inline-date').on('click', function (e) {
			$("#adults").val(1);
			$("#child").val(0);
			$("#number_guest").text("1 ADULT");
			
		});

		// js-accordion
		$(function () {
			// Cache selectors
			var $accordion = $(".js-accordion");
			var $pins = $(".pin-name");
			var $allPanels = $(" .accordion-panel").hide();
			var $allItems = $(".accordion-item");
			//console.log(imageSideSrc);
			$('.panel-0').show();

			// Event listeners
			$pins.on("click", function(){
				var pinTarget = $(this).data('target');
				$allPanels.slideUp();
				$(this).siblings().removeClass('active');
				$(this).addClass('active');
				$('#'+pinTarget).parent().addClass('is-open');
				$('#'+pinTarget).parent().siblings().removeClass('is-open');
				$('#'+pinTarget).slideDown();
			})
			$accordion.on("click", ".accordion-toggle", function () {
				// Toggle the current accordion panel and close others
				$allPanels.slideUp();
				$allItems.removeClass("is-open");
				if (
					$(this).next().is(":visible")
				) {
					$(".accordion-panel").slideUp();
					if (!$allItems.hasClass('is-open')) {
						
					}
				} else {
					$(this).next().slideDown().closest(".accordion-item").addClass("is-open");
					var $dataPin = $(this).data('pin');
					console.log($dataPin);
					$("."+$dataPin).addClass('active');
					$("."+$dataPin).siblings().removeClass('active');
				}
				return false;
			});
		});


		$('.js-media').on('click', function(e){
			$('#form-media').addClass('active');
			document.querySelector('#form-media').scrollIntoView({behavior: 'smooth'});
			e.preventDefault();
		})
		$('.js-close-form').on('click', function(e){
			$(this).parent().parent().removeClass('active');
			e.preventDefault();
		})
		//add dropdown selector submenu mobile
		

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		/**Slide landing page */

	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})

		$('.form-module__field select option:first-child').html('');

		

	};

}());
if(window.location.href.indexOf('#') > -1) {
	setTimeout(() => {
		let hasDirection = window.location.href.slice(window.location.href.indexOf('#'))
		// console.log(window.location.href.indexOf('#'));
		if(hasDirection){
			// console.log({ hasDirection });
			findSection(hasDirection);
		}
	}, 500);
} else {
	function getURLParameters() {
		const  fullURL = window.location.href;
		const url = new URL(fullURL);
		let searchParams = new URLSearchParams(url.search);

		let paramsObject = {};
		searchParams.forEach(function(value, name) {
			paramsObject[name] = value;
		});

		return paramsObject;
	}

	let urlParameters = getURLParameters();

	if (Object.keys(urlParameters).length > 0) {
		if(document.querySelector(`li.tab[data-tag="${urlParameters.target}"]`)) {
			let elementTarget = document.querySelector(`li.tab[data-tag="${urlParameters.target}"]`);
			elementTarget.click();
			elementTarget.parentElement.scrollIntoView({ behavior: "smooth", block:"start"});
			let parent = elementTarget.parentElement;
			
				setTimeout(() => {
					window.scrollBy(0, parent.getBoundingClientRect().top - 560);  
				}, 500);
			
			}
			
		} else {
		console.log("The URL does not contain any parameters.");
	}
}

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 0) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

// Anchor link functionality for mobile capacity chart
const anchorLink = document.getElementById('js-accordion-title-1670');
const room1670SiteURL = 'https://www.1670room.com/';	

//Function to stop opening & to redirect to 1670 room website after click
if (anchorLink) {
	anchorLink.addEventListener('click', function(e){
		e.stopPropagation();	
		window.open(room1670SiteURL, '_blank');
	});
}
